import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { ETheme } from '../../../../shared/enums/user/ETheme';
import { IUser } from '../../../../shared/interfaces/user/IUser';
import { darkPalette, lightPalette } from '../../../../shared/mui/palettes';
import { RootState } from '../../../../store/store';
interface IProps {
  open: boolean;
  handleClose: () => void;
  handleSubmit: () => void;
  children: JSX.Element;
  isUpdate?: boolean;
  departmentName?: string;
}
const EmployeeFormModal = ({
  open,
  handleClose,
  isUpdate = false,
  departmentName,
  handleSubmit,
  children,
}: IProps) => {
  const { t } = useTranslation();
  const { theme } = useSelector(
    (state: RootState) => state?.auth?.userData,
  ) as IUser;
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        className={'MuiModalBody'}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: { xs: '80%', lg: '30%' },
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            width: '100%',
            paddingBottom: '10px',
            borderBottom: `1px solid ${theme === ETheme.LIGHT ? lightPalette.primary.light : darkPalette.background.light}`,
          }}
        >
          <Typography id="modal-modal-title" variant="h6">
            {t(
              isUpdate
                ? 'departments.updateDepartment'
                : 'departments.createDepartment',
              { name: departmentName },
            )}
          </Typography>
        </Box>
        {children}
        <div>
          <Button
            variant={'contained'}
            color={'secondary'}
            size={'small'}
            onClick={handleClose}
            sx={{ marginRight: '10px' }}
          >
            {t('button.cancel')}
          </Button>
          <Button variant={'contained'} size={'small'} onClick={handleSubmit}>
            {t(isUpdate ? 'button.update' : 'button.create')}
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default EmployeeFormModal;
